import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const Shortlist: Site = {
  id: 'shortlist',
  logo: 'svg/shortlist.svg',
  label: 'Shortlist',
  analyticsName: 'shortlist',
  hostname: 'shortlist.com',
  platform: 'progressive',
  selector: `${progressiveVanillaSelector}, #content a`,
};
